import { AnyAction } from 'redux';

import { TagsReceivedAction, TAGS_RECEIVED } from '@ttstr/actions/tags';
import { Articles, IndexedTags, Product } from '@ttstr/api';
import { AppState } from '.';

export interface ReduxState {
  tagsReceived: boolean;
  tags: IndexedTags;
}

const initialState: ReduxState = {
  tagsReceived: false,
  tags: {},
};

const tags = (state: ReduxState = initialState, action: AnyAction): ReduxState => {
  switch (action.type) {
    case TAGS_RECEIVED: {
      const { tags } = (action as TagsReceivedAction).payload;

      return {
        ...state,
        tagsReceived: true,
        tags: tags
          ? tags.reduce(
              (previous, current) => ({
                ...previous,
                [current.id]: current,
              }),
              {}
            )
          : {},
      };
    }
    default:
      return state;
  }
};

export const getTags = (state: AppState) => {
  return state.Tags.tags;
};

export const getTagsReceived = (state: AppState) => {
  return state.Tags.tagsReceived;
};

export const getTagsFromProduct = (tags: IndexedTags, product: Product) => {
  if (!product) return [];

  return product.tag_ids.map((id) => tags[id]);
};

export const getTagsForProducts = (tags: IndexedTags, products: Articles) => {
  if (!tags) return {};
  return Object.entries(tags).reduce<IndexedTags>(
    (acc, [id, tag]) => (products.some((p) => p.tag_ids.includes(Number(id))) ? { ...acc, [id]: tag } : acc),
    {}
  );
};

export default tags;
